const SectionActionBar = ({ sectionName }) => {
  return (
    <div className="settle-sub-action-bar">
      <div className="w-100 height-25" style={{ height: "25px" }}>
        <div className="d-flex align-items-center height-25" style={{ justifyContent: "center" }}>
          <span className="text-uppercase m-l-5 text-white fw-bold cursor-default">
            {sectionName}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SectionActionBar;
